import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import Img from "gatsby-image";
import HoverTile from "../../Tile/HoverTile";
import { rejig2020Title } from "../../Tile/Tile";
// import Theme from '../../../vars/ThemeOptions'

const WrapRow = styled(Row)`
  margin-left: 10%;
  margin-top: 8vh;
  margin-bottom: 8vh;
  width: 90%;
  max-height: 25rem;
  height: 25rem;
  padding-bottom: 2rem;
  position: relative;
  .content-col {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    max-height: 25rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
  }
  @media only screen and (max-width: 767px) {
    width: 80%;
    margin-top: 22vh;
  }
`;

export const WideRight = ({ link }) => {
  //console.log("link: ", link);
  const { title, entry } = link;
  const { wideImage, slug } = entry;
  const { fluid } = wideImage ? wideImage : { fluid: null };
  const { json } = entry.jumpText;
  //console.log(fluid);
  return (
    <WrapRow>
      {fluid && (
        <Img
          fluid={fluid}
          alt={wideImage.title}
          style={{ width: "100%", height: "25rem" }}
        />
      )}
      <Col sm={12} className="content-col" style={{ padding: 0 }}>
        <HoverTile title={rejig2020Title(title)} json={json} slug={slug} />
      </Col>
    </WrapRow>
  );
};
